export enum OrderType {
  Sale = 'sale',
  SaleRefund = 'sale-refund',
}
